export default "__VITE_ASSET__5026a7ad__"